module.exports = "/_next/static/images/vynil_500x500-15c5270675dc41ccc9f66281a0f382ef.png.webp";